<template>
  <div class="relative">
    <div class="z-30 hidden lg:flex center-y left-0 py-12 px-11 rounded-full bg-white bg-orange text-white mr-16 cursor-pointer"
         @click="$refs.carousel.swiper.slidePrev()">
      <i class="fal fa-chevron-left fa-fw text-xl"></i>
    </div>

    <div class="z-30 hidden lg:flex center-y right-0 py-12 px-11 rounded-full bg-white bg-orange text-white cursor-pointer"
         @click="$refs.carousel.swiper.slideNext()">
      <i class="fal fa-chevron-right fa-fw text-xl"></i>
    </div>

    <div class="px-10 lg:px-80">
      <swiper-container ref="carousel"
                        :slides-per-view="$mq.lg ? 2 : 1"
                        swiper-slide-next="test"
                        :space-between="30"
                        :enabled="true"
                        loading="lazy">
        <swiper-slide v-for="(event, key) in events" :key="key">
          <div class="relative overflow-hidden">
            <img class="w-full object-cover h-240 md:h-306 lg:mb-0 lg:scale-125 lg:transform lg:transition lg:duration-500 lg:hover:scale-100"
                 loading="lazy"
                 :src="event.images.background['lg']"
                 :alt="event.images.altImage">
            <div class="bottom-0 px-32 text-black rounded-tr-34 overflow-hidden w-9/12 text-white absolute py-16 bg-transparent-light-gray"
                 style="backdrop-filter: blur(8px); overflow-wrap: break-word;">
              <a :href="event.url" class="block">
                <h2 class="text-20 lg:text-32 pr-22">{{ event.title }}</h2>
                <span class="text-orange text-16 font-thin float-right absolute top-1/2"
                      style="transform: translateY(-50%); right: 20px">
                    <i class="fal fa-long-arrow-right ml-12"></i>
                  </span>
              </a>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</template>

<script>
import { register } from 'swiper/element/bundle';
import 'swiper/swiper-bundle.css';

register();
export default {
  props: {
    events: {
      required: true,
    }
  }
}
</script>
